import PubSub from 'pubsub-js';
import { TOPIC_IDS } from '@/js/constants';
import { nextTick } from '@/js/utils/browser';

export class Menu {
  private selector: string;
  private el: HTMLElement;
  private togglerEl: HTMLElement[];
  private state: {
    isExpanded: boolean;
  };
  private closeCallback: (e: Event) => void;

  constructor(selector: string) {
    this.selector = selector;
    this.el = document.querySelector(selector) as HTMLElement;
    this.togglerEl = [];
    this.state = {
      isExpanded: false,
    };
    this.closeCallback = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target !== this.el) return;
      this.changeAttribute(false);
      this.el.removeEventListener('transitionend', this.closeCallback);
    };

    if (!this.el) return;

    this.bind();
    this.initialize();
  }

  bind() {
    this.onPointerDown = this.onPointerDown.bind(this);
    this.changeAttribute = this.changeAttribute.bind(this);
    this.expand = this.expand.bind(this);
    this.close = this.close.bind(this);

    PubSub.subscribe(TOPIC_IDS.WINDOW_CHANGE_BREAKPOINT, (_, state) => {
      if (this.state.isExpanded) {
        this.close();
      }
    });
  }

  initialize() {
    this.togglerEl = [...document.querySelectorAll(`${this.selector}-toggler`)] as HTMLElement[];
    this.togglerEl.forEach((it) => {
      // ハンバーガーボタンが取得される
        it.addEventListener('click', this.onPointerDown);
    });
  }

  onPointerDown(e: PointerEvent | MouseEvent) {
    e.preventDefault();

    if (this.state.isExpanded) {
      this.close();
    } else {
      this.expand();
    }
  }

  changeAttribute(bool: boolean) {
    [...this.togglerEl, this.el].forEach((it) => {
      it.setAttribute('aria-expanded', bool.toString());
    });
  }

  async expand() {
    this.state.isExpanded = true;
    this.changeAttribute(true);
    // displayの切り替えによるリフローを待機
    await nextTick();
    // 開閉アニメーション
    this.el.classList.add('is-expanded');

    // スクロールを制限
    PubSub.publish(TOPIC_IDS.DISABLE_SCROLL_DISABLE);
  }

  async close() {
    this.state.isExpanded = false;

    // 開閉アニメーション後にdisplayを切り替える
    this.el.addEventListener('transitionend', this.closeCallback);

    // 開閉アニメーション
    this.el.classList.remove('is-expanded');

    // スクロール制御を解除
    PubSub.publish(TOPIC_IDS.DISABLE_SCROLL_RELEASE);
  }
}
